<template>
  <el-select v-model="value" placeholder="请选择" @change="changeValue($event)" clearable>
    <el-option
      v-for="item in forceTypeData"
      :key="item.code"
      :label="item.name"
      :value="item.code"
    />
  </el-select>
</template>
<script>
export default {
  data() {
    return {
      value: '',
      forceTypeData: [],
      callbackMethod: ''
    }
  },
  methods: {
    changeValue(e) {
      this.$emit(this.callbackMethod, this.value)
    },
    setSelectValue(value) {
      this.value = value
    },
    initDict(forceTypeData) {
      this.forceTypeData = forceTypeData
    },
    initData(forceTypeData,callbackMethod) {
      this.forceTypeData = JSON.parse(JSON.stringify(forceTypeData))
      this.callbackMethod = callbackMethod
    }
  }
}
</script>
